import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { format_date_technical } from '../../functions/functions_formatting.js';


export default class Triplist extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }


    render() {

        return (
            <div className="admindashboard__section">
                <div className="admindashboard__section__title text-title">
                    Trips
                </div>
                <div className="admindashboard__section__content">
                    {(this.props.tripdata && this.props.tripdata.length >= 1) &&
                        <div className="admindashboard__section__content__table admindashboard__section__content__table--trip">

                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Trip ID
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header admindashboard__section__content__table__element--double">
                                Title
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header admindashboard__section__content__table__element--double">
                                Cities
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Rating
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Activities count
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Views count
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header admindashboard__section__content__table__element--double">
                                Settings
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Owner
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Created
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Updated
                            </div>

                            {this.props.tripdata.map((trip, i) => (
                                <React.Fragment key={i}>
                                    <div onClick={() => this.props.setTrip(trip.trip_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                        {trip.trip_id ? trip.trip_id : "-"}
                                    </div>
                                    <Link to={"/trip/" + trip.trip_id} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--double">
                                        {trip.title ? trip.title : "-"}
                                    </Link>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--double">
                                        {trip.cities ? trip.cities.join(", ") : "-"}
                                        {trip.countries ? " (" + trip.countries.join(", ") + ")" : "-"}
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {trip.rate ? trip.rate : "-"}
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {trip.activities_count ? trip.activities_count : "-"}
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {trip.views ? trip.views : "-"}
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--double">
                                        {trip.settings.active ? "Active" : "Deactivated"}
                                        {", "}
                                        {trip.settings.public ? "Public" : "Private"}
                                        {", "}
                                        {trip.settings.findable ? "Findable" : "Link-only"}
                                    </div>
                                    <Link to={"/u/" + trip.owner.username} className="admindashboard__section__content__table__element">
                                        {/* {trip.owner_id ? trip.owner_id : "-"} */}
                                        {trip.owner.username ? trip.owner.username : "-"}
                                    </Link>
                                    <div className="admindashboard__section__content__table__element">
                                        {trip.created ? format_date_technical(trip.created) : "-"}
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {trip.updated ? format_date_technical(trip.updated[trip.updated.length - 1]) : "-"}
                                    </div>
                                </React.Fragment>
                            ))}
                        </div>
                    }
                </div>
            </div>
        )
    }
}